import DuplicateSession from '@/connection/sessions/duplicate-session';
import { serializeError, getPayloadMessage, SerializedError } from '@/store/utils/serialize-error';
import toastTrigger from '@ui/toast/toast-trigger';
import { ProjectStateReducerCreator } from '../types';
import { Session } from '@/types/session.types';

const duplicateSessionReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (
      { event, projectUuid, session }: { event: number; projectUuid: string; session: Session },
      { rejectWithValue }
    ) => {
      try {
        const result = await DuplicateSession({
          event,
          projectUuid,
          session,
        });
        if ('error' in result) {
          console.error('duplicateSession error', result.error);
          return rejectWithValue(serializeError(result.error));
        }
        return result;
      } catch (e) {
        console.error(e);
        return rejectWithValue(serializeError(e));
      }
    },
    {
      fulfilled: (state, action) => {
        const newSession = action.payload;
        state.duplicatedSession = newSession;
        if (newSession && state.workingProject) {
          newSession.timestamp = new Date(newSession.timestamp || 0).valueOf();
          newSession.end_timestamp = new Date(newSession.end_timestamp || 0).valueOf();
          state.workingProject.sessions = [newSession, ...(state.workingProject?.sessions ?? [])];
          state.workingProject.settings = {
            ...state.workingProject.settings,
            display_homepage: state.workingProject.sessions.length > 1,
          };
        }
      },
      pending: (state) => {
        state.duplicatedSession = null;
        state.duplicatingSession = true;
      },
      rejected: (state, action) => {
        state.duplicatedSession = null;
        console.error('Error duplicating session:', action.error);
        const errMsg =
          getPayloadMessage(action.payload as SerializedError | string | undefined) || action.error?.message;
        toastTrigger(
          `<div>
              <h4 class="H4">There was an error duplicating the session.</h4>
              <p class="S1">${errMsg}</p>
            </div>`,
          {
            type: 'error',
            autoClose: 5000,
          }
        );
      },
      settled: (state) => {
        state.duplicatingSession = false;
      },
    }
  );
};

export default duplicateSessionReducer;
